var _rect, _g, _rect2, _path, _path2, _path3, _tspan, _tspan2, _path4, _tspan3, _path5, _tspan4, _path6, _tspan5, _path7, _tspan6, _path8, _tspan7, _path9, _tspan8, _path10, _tspan9, _path11, _tspan10, _path12, _tspan11, _path13, _tspan12, _path14, _tspan13, _path15, _tspan14, _tspan15, _path16, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _tspan27, _g2, _tspan28, _tspan29, _rect3, _tspan30, _tspan31, _tspan32, _tspan33, _rect4, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _rect5, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _rect6, _tspan44, _tspan45, _tspan46, _tspan47, _tspan48, _tspan49, _rect7, _tspan50, _tspan51, _tspan52, _tspan53, _rect8, _tspan54, _tspan55, _tspan56, _tspan57, _tspan58, _tspan59, _tspan60, _rect9, _tspan61, _tspan62, _tspan63, _rect10, _tspan64, _tspan65, _tspan66, _rect11, _tspan67, _tspan68, _tspan69, _tspan70, _rect12, _tspan71, _tspan72;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2022,
    height: 903,
    viewBox: "0 0 2022 903",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2022,
    height: 903,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g_svg"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_bkg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    width: 2022,
    height: 903,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g_main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g_chart"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 9,
    y: 29,
    width: 1716,
    height: 696,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart_line",
    d: "M52.29 844.86C238.55 826.18 428.7 812.27 614.95 737.68C661.52 719.03 707.38 685.61 753.95 666.68C800.52 647.75 843.38 630.25 889.95 622.68C936.52 615.11 985.4 619.25 1031.95 611.68C1078.5 604.11 1125.38 302.68 1171.95 302.68C1218.52 302.68 1262.95 813.62 1309.52 813.62C1356.09 813.62 1402.4 744.68 1448.95 744.68C1495.5 744.68 1542.34 828.2 1588.95 833.68C1635.56 839.16 1682.07 840.59 1728.64 841.97",
    stroke: "#3E58A7",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chart_Horizontal_Numbers"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "xAxis",
    d: "M58.1406 860.059V853.939H1728.67V860.059",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M58.1406 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,011"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2011
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.59,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 71.022,
    y: 877.119
  }, "11"))), /*#__PURE__*/React.createElement("text", {
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 46.7002,
    y: 877.119
  }, "20")))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M197.351 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,012"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2012,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 185.24,
    y: 877.119
  }, "2012"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M336.561 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,013"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2013,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 324.311,
    y: 877.119
  }, "2013"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M475.77 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,014"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2014,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 463.5,
    y: 877.119
  }, "2014"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M614.95 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,015"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2015,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 602.87,
    y: 877.119
  }, "2015"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M754.19 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,016"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2016,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 742,
    y: 877.119
  }, "2016"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M893.4 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,017"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2017,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 881.46,
    y: 877.119
  }, "2017"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M1032.61 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,018"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2018,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 1020.46,
    y: 877.119
  }, "2018"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M1171.82 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,019"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2019,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 1159.63,
    y: 877.119
  }, "2019"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M1311.04 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,020"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2020,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 1298.18,
    y: 877.119
  }, "2020"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M1450.25 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,021"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2021,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 1438.14,
    y: 877.119
  }, "2021"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M1589.46 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,022"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2022,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 1576.69,
    y: 877.119
  }, "2022"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 17",
    d: "M1728.67 853.38V860.06",
    stroke: "#010101",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "2,023"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2023,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.4485,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 1715.75,
    y: 877.119
  }, "2023"))))), /*#__PURE__*/React.createElement("text", {
    id: "Year",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 1789,
    y: 874.545
  }, "Year")))), /*#__PURE__*/React.createElement("g", {
    id: "Chart_Vertical_Numbers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 19",
    d: "M51.3807 853.36H44.0107",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    id: 0,
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.6852,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 23.0303,
    y: 854.601
  }, "0")))), /*#__PURE__*/React.createElement("g", {
    id: 5
  }, /*#__PURE__*/React.createElement("text", {
    id: "5_2",
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.6852,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 23.1797,
    y: 797.591
  }, "5")))), /*#__PURE__*/React.createElement("g", {
    id: 10
  }, /*#__PURE__*/React.createElement("text", {
    id: "10_2",
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.6852,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 18.6201,
    y: 740.871
  }, "10")))), /*#__PURE__*/React.createElement("g", {
    id: 15
  }, /*#__PURE__*/React.createElement("text", {
    id: "15_2",
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.6852,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 18.7803,
    y: 684.161
  }, "15")))), /*#__PURE__*/React.createElement("g", {
    id: 20
  }, /*#__PURE__*/React.createElement("text", {
    id: "20_2",
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.6852,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 17.29,
    y: 627.441
  }, "20")))), /*#__PURE__*/React.createElement("g", {
    id: 25
  }, /*#__PURE__*/React.createElement("text", {
    id: "25_2",
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.6852,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 17.4502,
    y: 570.721
  }, "25")))), /*#__PURE__*/React.createElement("g", {
    id: 30
  }, /*#__PURE__*/React.createElement("text", {
    id: "30_2",
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.6852,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 17,
    y: 514.001
  }, "30")))), /*#__PURE__*/React.createElement("g", {
    id: 35
  }, /*#__PURE__*/React.createElement("text", {
    id: "35_2",
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.6852,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 17.1504,
    y: 457.291
  }, "35")))), /*#__PURE__*/React.createElement("g", {
    id: 40
  }, /*#__PURE__*/React.createElement("text", {
    id: "40_2",
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.6852,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 17.1104,
    y: 400.572
  }, "40")))), /*#__PURE__*/React.createElement("g", {
    id: 45
  }, /*#__PURE__*/React.createElement("text", {
    id: "45_2",
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.6852,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 17.1104,
    y: 343.851
  }, "45")))), /*#__PURE__*/React.createElement("g", {
    id: 50
  }, /*#__PURE__*/React.createElement("text", {
    id: "50_2",
    fill: "#010101",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17.6852,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 19.1104,
    y: 287.131
  }, "50")))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M51.9502 280.681H43.9502",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "yAxis",
    d: "M51.9502 853.361V280.681",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 18_2",
    d: "M44.0098 853.36H52.0098",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 20",
    d: "M51.3798 796.09H44.0098",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M51.3798 738.83H44.0098",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M51.3798 681.561H44.0098",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 23",
    d: "M51.3798 624.29H44.0098",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 25",
    d: "M51.3798 567.021H44.0098",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M51.3798 509.75H44.0098",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M51.3798 452.48H44.0098",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 28",
    d: "M51.3798 395.18H44.0098",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 29",
    d: "M51.3798 337.95H44.0098",
    stroke: "#010101",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    id: "USD Billion",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 3,
    y: 248.545
  }, "USD Billion")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "circles"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle2",
    cx: 753.71,
    cy: 667.44,
    r: 8.76,
    fill: "black",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle0",
    cx: 51.7102,
    cy: 844.44,
    r: 8.76,
    fill: "black",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle1",
    cx: 614.71,
    cy: 736.44,
    r: 8.76,
    fill: "black",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle9",
    cx: 1728.71,
    cy: 844.44,
    r: 8.76,
    fill: "black",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle3",
    cx: 892.71,
    cy: 620.44,
    r: 8.76,
    fill: "black",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle4",
    cx: 1034.71,
    cy: 611.44,
    r: 8.76,
    fill: "black",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle5",
    cx: 1172.71,
    cy: 301.44,
    r: 8.76,
    fill: "black",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle6",
    cx: 1311.71,
    cy: 813.44,
    r: 8.76,
    fill: "black",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle7",
    cx: 1450.71,
    cy: 746.44,
    r: 8.76,
    fill: "black",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle8",
    cx: 1589.71,
    cy: 836.44,
    r: 8.76,
    fill: "black",
    stroke: "black",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "labels"
  }, /*#__PURE__*/React.createElement("g", {
    id: "label_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "0.15 B",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 78,
    y: 815.269
  }, "0.15 B")))), /*#__PURE__*/React.createElement("g", {
    id: "descGroup1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "First location opened in Soho,Manhattan.",
    fill: "#404140",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 78,
    y: 748.591
  }, "First location opened in Soho,Manhattan.")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    x: 78,
    y: 706,
    width: 55,
    height: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Topic1",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 88,
    y: 718.591
  }, "Start")))), /*#__PURE__*/React.createElement("g", {
    id: "label_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "10 B",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 529,
    y: 733.909
  }, "10 B")))), /*#__PURE__*/React.createElement("g", {
    id: "descGroup2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Named to Fast Company\xE2\x80\x99s 50",
    fill: "#404140",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 378,
    y: 634.591
  }, "Named to Fast Company&#x2019;s 50 "))), /*#__PURE__*/React.createElement("text", {
    id: "Most Innovative Companies list.",
    fill: "#404140",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 378,
    y: 656.591
  }, "Most Innovative Companies list.")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6_2",
    x: 378,
    y: 590,
    width: 58,
    height: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Topic2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 382,
    y: 601.591
  }, "Named")))), /*#__PURE__*/React.createElement("g", {
    id: "label_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "descGroup3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Announced layoffs of 7%",
    fill: "#404140",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 686,
    y: 789.591
  }, "Announced layoffs of 7% "))), /*#__PURE__*/React.createElement("text", {
    id: "implemented a temporary hiring freeze",
    fill: "#404140",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 686,
    y: 810.194
  }, "implemented a temporary hiring freeze"))), /*#__PURE__*/React.createElement("text", {
    id: "Launched co-living venture",
    fill: "#404140",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 686,
    y: 830.799
  }, "Launched  co-living venture")))), /*#__PURE__*/React.createElement("g", {
    id: "text3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "16 B",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 667,
    y: 637.909
  }, "16 B")))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6_3",
    x: 686,
    y: 743.59,
    width: 135,
    height: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Topic3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 691,
    y: 755.591
  }, "Announced Layoff")))), /*#__PURE__*/React.createElement("g", {
    id: "label_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "20 B",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 817,
    y: 582.909
  }, "20 B  ")))), /*#__PURE__*/React.createElement("g", {
    id: "descGroup4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "First location in Singapore.",
    fill: "#404140",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 904,
    y: 707.591
  }, "First location in Singapore."))), /*#__PURE__*/React.createElement("text", {
    id: "Acquired Meetup for $156 million (aprox)",
    fill: "#404140",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 904,
    y: 724.591
  }, "Acquired Meetup for $156 million (aprox)"))), /*#__PURE__*/React.createElement("text", {
    id: "expansion plan into China.",
    fill: "#404140",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 904,
    y: 746.591
  }, "expansion plan into China. ")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6_4",
    x: 904,
    y: 662.189,
    width: 132,
    height: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Topic4",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 909,
    y: 674.591
  }, "Open First Branch")))), /*#__PURE__*/React.createElement("g", {
    id: "label_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "descGroup5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Acquired Naked Hub for $400 million.",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 822,
    y: 424.591
  }, "Acquired  Naked Hub for $400 million."))), /*#__PURE__*/React.createElement("text", {
    id: "Purchased a Gulfstream G650 Jet for around $60",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 822,
    y: 446.591
  }, "Purchased a Gulfstream G650 Jet for around  $60  "))), /*#__PURE__*/React.createElement("text", {
    id: "Adam Neumann's excessive spending",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 822,
    y: 468.591
  }, "Adam Neumann&#39;s excessive spending"))), /*#__PURE__*/React.createElement("text", {
    id: "Lost over $2 billion.",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 822,
    y: 490.591
  }, "Lost over $2 billion.")))), /*#__PURE__*/React.createElement("g", {
    id: "text5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "21 B",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 980,
    y: 558.909
  }, "21 B")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6_5",
    x: 822,
    y: 379,
    width: 207,
    height: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Topic5",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 826,
    y: 391.591
  }, "Acquired Chinese Coworking")))), /*#__PURE__*/React.createElement("g", {
    id: "label_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "descGroup6"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Proposed initial public offering got the highest Valuation.",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 1214,
    y: 291.591
  }, "Proposed initial public offering got the highest Valuation."))), /*#__PURE__*/React.createElement("text", {
    id: "criticism over its governance, business model, and ability to turn a profit.",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 1214,
    y: 315.591
  }, "criticism over its governance, business model, and ability to turn a profit.  ")))), /*#__PURE__*/React.createElement("g", {
    id: "text6"
  }, /*#__PURE__*/React.createElement("text", {
    id: "47 B",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 1144.95,
    y: 269.589
  }, "47 B")))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6_6",
    x: 1216.95,
    y: 245.68,
    width: 151,
    height: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Topic6",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan54 || (_tspan54 = /*#__PURE__*/React.createElement("tspan", {
    x: 1221.95,
    y: 258.381
  }, "Initial Public Offering")))), /*#__PURE__*/React.createElement("g", {
    id: "label_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text7"
  }, /*#__PURE__*/React.createElement("text", {
    id: "2.9 B",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan55 || (_tspan55 = /*#__PURE__*/React.createElement("tspan", {
    x: 1285,
    y: 745.909
  }, "2.9 B")))), /*#__PURE__*/React.createElement("g", {
    id: "descGroup7"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Announced the temporary closure of 100 buildings due to the COVID-19.",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan56 || (_tspan56 = /*#__PURE__*/React.createElement("tspan", {
    x: 1278.05,
    y: 461.591
  }, "Announced the temporary closure of 100 buildings due to the COVID-19. "))), /*#__PURE__*/React.createElement("text", {
    id: "Laid off 250 employees",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan57 || (_tspan57 = /*#__PURE__*/React.createElement("tspan", {
    x: 1277,
    y: 483.591
  }, "Laid off 250 employees"))), /*#__PURE__*/React.createElement("text", {
    id: "McKelvey announced leaving",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan58 || (_tspan58 = /*#__PURE__*/React.createElement("tspan", {
    x: 1277,
    y: 505.591
  }, "McKelvey announced leaving  "))), /*#__PURE__*/React.createElement("text", {
    id: "Vacated 66 locations and re-negotiated lower rent,",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan59 || (_tspan59 = /*#__PURE__*/React.createElement("tspan", {
    x: 1275,
    y: 527.591
  }, "Vacated 66 locations and re-negotiated lower rent, "))), /*#__PURE__*/React.createElement("text", {
    id: "lease changes at more than 150 locations.",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan60 || (_tspan60 = /*#__PURE__*/React.createElement("tspan", {
    x: 1277,
    y: 549.591
  }, "lease changes at more than 150 locations.")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6_7",
    x: 1278,
    y: 416.05,
    width: 221,
    height: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Topic7",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan61 || (_tspan61 = /*#__PURE__*/React.createElement("tspan", {
    x: 1283,
    y: 428.591
  }, "Announced Temporary Closure")))), /*#__PURE__*/React.createElement("g", {
    id: "label_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "descGroup8"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Shares began trading on NYSE .",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan62 || (_tspan62 = /*#__PURE__*/React.createElement("tspan", {
    x: 1432,
    y: 652.591
  }, "Shares began trading on NYSE .")))), /*#__PURE__*/React.createElement("g", {
    id: "text8"
  }, /*#__PURE__*/React.createElement("text", {
    id: "9 B",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan63 || (_tspan63 = /*#__PURE__*/React.createElement("tspan", {
    x: 1432,
    y: 716.909
  }, "9 B")))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6_8",
    x: 1432,
    y: 607,
    width: 207,
    height: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Topic8",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan64 || (_tspan64 = /*#__PURE__*/React.createElement("tspan", {
    x: 1436,
    y: 619.591
  }, "Trading on NYSE")))), /*#__PURE__*/React.createElement("g", {
    id: "label_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "descGroup9"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Closed its offices in Russia",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan65 || (_tspan65 = /*#__PURE__*/React.createElement("tspan", {
    x: 1547,
    y: 781.591
  }, "Closed its offices  in Russia")))), /*#__PURE__*/React.createElement("g", {
    id: "text9"
  }, /*#__PURE__*/React.createElement("text", {
    id: "1.13 B",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan66 || (_tspan66 = /*#__PURE__*/React.createElement("tspan", {
    x: 1573,
    y: 818.909
  }, "1.13 B")))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6_9",
    x: 1547,
    y: 736.51,
    width: 112,
    height: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Topic9",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan67 || (_tspan67 = /*#__PURE__*/React.createElement("tspan", {
    x: 1550,
    y: 748.591
  }, "Close in Russia")))), /*#__PURE__*/React.createElement("g", {
    id: "label_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "descGroup10"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Announced Chapter 11 bankruptcy",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan68 || (_tspan68 = /*#__PURE__*/React.createElement("tspan", {
    x: 1757,
    y: 746.591
  }, "Announced Chapter 11 bankruptcy "))), /*#__PURE__*/React.createElement("text", {
    id: "Stock Trading suspended",
    fill: "#40403F",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan69 || (_tspan69 = /*#__PURE__*/React.createElement("tspan", {
    x: 1757,
    y: 768.591
  }, "Stock Trading suspended ")))), /*#__PURE__*/React.createElement("g", {
    id: "text10"
  }, /*#__PURE__*/React.createElement("text", {
    id: "0.4 B",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan70 || (_tspan70 = /*#__PURE__*/React.createElement("tspan", {
    x: 1744,
    y: 841.909
  }, "0.4 B")))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6_10",
    x: 1757,
    y: 701,
    width: 119.971,
    height: 16,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Topic10",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan71 || (_tspan71 = /*#__PURE__*/React.createElement("tspan", {
    x: 1766.47,
    y: 713.591
  }, "Bankrupt")))))), /*#__PURE__*/React.createElement("g", {
    id: "g_header"
  }, /*#__PURE__*/React.createElement("text", {
    id: "WeWork Drop",
    fill: "#4C4C4D",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 60,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan72 || (_tspan72 = /*#__PURE__*/React.createElement("tspan", {
    x: 760.24,
    y: 177.318
  }, "WeWork Drop")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalSvg);
export default __webpack_public_path__ + "static/media/finalSvg.a753e4cadba2298f121bb7d8c260cbea.svg";
export { ForwardRef as ReactComponent };